export default function HideLiveChat() {
  return <style dangerouslySetInnerHTML={{
    __html: `
    #chat-widget-container {
      display: none;
    }
  `,
  }}
  />
}
